
import { Component, Inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { MapsAPILoader } from '@agm/core';
import { DOCUMENT } from '@angular/common';

import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { FuseConfigService } from '@fuse/services/config.service';
import { FuseNavigationService } from '@fuse/components/navigation/navigation.service';
import { FuseSidebarService } from '@fuse/components/sidebar/sidebar.service';
import { FuseSplashScreenService } from '@fuse/services/splash-screen.service';

import { customer as customerNavigation,
  dispatcher as dispatcherNavigation,
  manager as managerNavigation,
  administrator as administratorNavigation
} from 'app/navigation/navigation';

import { initializeParse } from 'app/components/data/core/cd-parse';
import { AuthenticationService } from 'app/authentication/authentication.service';
import { TransportUnitBreakageService } from 'app/notification/transport-unit-breakage.service';
import { OrdersProblemsService } from 'app/notification/order-problems.service';

import { LocaleService } from 'app/components/locale/locale.service';
import { common, users } from 'app/main/locale/locale';
import { app, navigation } from 'app/locale/locale';

const locales = [
  common,
  app,
  navigation,
  users,
];

@Component({
    selector   : 'app',
    templateUrl: './app.component.html',
    styleUrls  : ['./app.component.scss']
})
export class AppComponent {

    fuseConfig: any;

    private _unsubscribeAll: Subject<any>;

    constructor(
        @Inject(DOCUMENT) private document: any,
        private _fuseConfigService: FuseConfigService,
        private _fuseNavigationService: FuseNavigationService,
        private _fuseSidebarService: FuseSidebarService,
        private _fuseSplashScreenService: FuseSplashScreenService,
        private _authenticationService: AuthenticationService,
        private _transportUnitBreakageService: TransportUnitBreakageService,
        private _orderProblems: OrdersProblemsService,
        private _title: Title,
        private _mapsAPILoader: MapsAPILoader,
        private _localeService: LocaleService
    )
    {
        this._fuseNavigationService.register('none', []);
        this._fuseNavigationService.register('customer', customerNavigation);
        this._fuseNavigationService.register('dispatcher', dispatcherNavigation);
        this._fuseNavigationService.register('manager', managerNavigation);
        this._fuseNavigationService.register('administrator', administratorNavigation);

        this._localeService.loadLocales(locales);

        // Set the private defaults
        this._unsubscribeAll = new Subject();

        this._mapsAPILoader.load().then(() => {console.log("Maps API loaded")});
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    ngOnInit(): void {
      this.parseInitialize();
      this._fuseConfigService.config
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((config) => {

                this.fuseConfig = config;

                // Color theme - Use normal for loop for IE11 compatibility
                for ( let i = 0; i < this.document.body.classList.length; i++ )
                {
                    const className = this.document.body.classList[i];

                    if ( className.startsWith('theme-') )
                    {
                        this.document.body.classList.remove(className);
                    }
                }

                this.document.body.classList.add(this.fuseConfig.colorTheme);
            });

      this._authenticationService.updateNavigation();

      this._localeService.translateService.get("CargoDeal").subscribe(title => {
        this._title.setTitle(title);
      });

      this._transportUnitBreakageService.subscribe();
      this._orderProblems.subscribe();
    }

    ngOnDestroy(): void {
      this._transportUnitBreakageService.unsubscribe();
      this._orderProblems.unsubscribe();
      // Unsubscribe from all subscriptions
      this._unsubscribeAll.next();
      this._unsubscribeAll.complete();
    }

    private parseInitialize() {
      initializeParse();
    }
}
